import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import GraphQL from '../../../GraphQL';
import MemoTemplateForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import {
  memoTemplateById,
  saveMemoTemplateMutation,
} from '../../../shared/queries/MemoTemplates';

const MemoTemplateFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({
    id: 0,
    active: true,
  });
  const [formOn, setFormOn] = useState(false);

  const backClickHandler = () => {
    history.push(`/minime/template-${match.params.type}`);
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const findById = (id, type) => {
    showLoading();
    const query = memoTemplateById(id, type);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.memoTemplateListByFilter) {
          setDto({
            ...res.memoTemplateListByFilter[0],
          });
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const handleSubmit = (values) => {
    const mutation = saveMemoTemplateMutation(match.params.type, values);
    showLoading();
    GraphQL(mutation, {
      defaultTitle: values.defaultTitle,
      defaultBodyInHTML: values.defaultBodyInHTML,
      defaultBody: values.defaultBody,
    })
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id, match.params.type);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t(`panels.template-${match.params.type}`)}>
      {formOn && (
        <MemoTemplateForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
        />
      )}
    </SmartCard>
  );
};

MemoTemplateFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(MemoTemplateFormHandler)
);
